import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnterpriseLockService } from '@core/service/enterprise-lock.service';

@Injectable()
export class EnterpriseLockInterceptor implements HttpInterceptor {
  constructor(private enterpriseLockService: EnterpriseLockService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 423 && err.error) {
          this.enterpriseLockService.onHttpLockDetected({
            enterpriseId: '',
            action: 'locked',
            jobType: err.error.jobType,
            jobId: err.error.jobId,
            startedAt: err.error.startedAt,
          });
        }
        return throwError(() => err);
      })
    );
  }
}
